import configs from "configs";

export default {
  API_URL: configs.REACT_APP_SERVER_URL,
  FIlE_UPLOAD: `${configs.FILE_IMAGE_URL}`,
  FILE_DOWNLOAD: `${configs.FILE_DOWNLOAD_URL}`,
  IMG_URL: configs.FILE_IMAGE_URL,
  GOOGLE_KEY: configs.GOOGLE_KEY,
  PROMOTION_URL: configs.REACT_APP_PROMOTION_URL,

  // CMS Api url
  PRIVACY_POLICY: "PRIVACY_POLICY",

  // Posts api url
  POSTS: "posts",

  // Auth api url
  LOGIN: "admin/login",
  LOGOUT: "admin/logout",

  REFRESH_TOKEN: "admin/refresh-access-token",

  FORGOT_PW: "admin/forgot-password",

  RESET_PW: "admin/reset-password",

  RESET_USER_PW: "user/reset-password",

  GET_COLUMN_TABLE_SETTINGS: "admin/table-column-settings",

  //Delete User Account
  DELETE_USER_ACCOUNT: "/delete-user-account",

  // User profile url
  PROFILE: "admin/profile",
  EDIT_PROFILE: "admin/edit-profile",
  FILE_UPLOAD: "admin/image-file-upload",
  FILE_UPLOAD_BASE: "admin/image-file-upload-base64",
  CHANGE_PASSWORD: "admin/change-password",
  GLOBAL_CONFIG: "admin/global-config",
  DELETE_PROFILE: "admin",

  // Master => Timezone
  TIMEZONE: "master/timezone",
  TIMEZONE_LIST: "master/timezone/listing",
  // Master => Country
  COUNTRY: "master/country",
  CURRENCY_LIST: "master/currency",
  // Master => Language
  LANGUAGE: "master/language",
  GET_LANGUAGE: "master/language/listing",

  // Master => cities
  CITY_LISTING: "/city/listing",
  ADD_CITY: "/city",
  CHANGE_CITY: "/city",
  GET_CITY_DROPDOWN: "/city/dropdown",
  DELETE_CITY: "/city",
  EDIT_CITY: "/city",

  // Master => clubType
  CLUB_TYPE_LIST: "/club-type/listing",
  ADD_CLUB_TYPE: "/club-type",
  CHANGE_CLUB_TYPE: "/club-type",
  DELETE_CLUB_TYPE: "/club-type",
  EDIT_CLUB_TYPE: "/club-type",
  DROPDOWN_CLUB_TYPE: "/club-type/dropdown",

  // Master => zones
  ZONES_LIST: "/zone/listing",
  ADD_ZONES: "/zone",
  CHANGE_ZONES: "/zone",
  DELETE_ZONES: "/zone",
  EDIT_ZONES: "/zone",
  DROPDOWN_ZONES: "/zone/dropdown",

  // Master => Drink Type
  DRINK_TYPE: "/drink-type/listing",
  ADD_DRINK_TYPE: "/drink-type",
  CHANGE_DRINK_TYPE: "/drink-type",
  DELETE_DRINK_TYPE: "/drink-type",
  EDIT_DRINK_TYPE: "/drink-type",
  DRINK_TYPE_DROPDOWN: "/drink-type/dropdown",

  // Master => music type
  MUSIC_TYPE_LIST: "/music-type/listing",
  ADD_MUSIC_TYPE: "/music-type",
  CHANGE_MUSIC_TYPE: "/music-type",
  DELETE_MUSIC_TYPE: "/music-type",
  EDIT_MUSIC_TYPE: "/music-type",
  DROPDOWN_MUSIC_TYPE: "/music-type/dropdown",
  // Master => outfites
  OUTFITS_LIST: "/outfit/listing",
  ADD_OUTFITS: "/outfit",
  CHANGE_OUTFITS: "/outfit",
  DELETE_OUTFITS: "/outfit",
  EDIT_OUTFITS: "/outfit",
  DROPDOWN_OUTFIT: "/outfit/dropdown",

  // Master => plans
  PLANS_LIST: "/plan/listing",
  ADD_PLANS: "/plan",
  CHANGE_PLANS: "/plan",
  PIN_PLAN: "/plan/pin",
  UNPIN_PLAN: "/plan/un-pin",
  DELETE_PLANS: "/plan",
  EDIT_PLANS: "/plan",
  FILE_UPLOAD_PLANS: "/plan/image-file-upload",
  DROPDOWN_PLAN: "/plan/dropdown",

  //  settings
  META_DATA: "settings/general/meta-data",
  SITE_SETTING: "settings/general/site-settings",
  DATE_TIME: "settings/general/date-time",
  ANALYTICAL_DATA: "settings/general/analytical-data",
  SITE_UN_MAINTENANCE: "settings/general/site-un-maintenance",
  SOCIAL_MEDIA_SDK: "settings/social-media/social-media-sdk",
  SOCIAL_MEDIA_LINK: "settings/social-media/social-media-link",
  CHANGE_STATUS: "settings/social-media/sdk",
  SMTP_DETAILS: "settings/smtp",
  SMS_DETAILS: "settings/sms",
  NOTIFICATION: "settings/email-settings/notifications",
  LANGUAGE_MESSAGES: "settings/language-preferences/messages",
  LANGUAGE_LABEL: "settings/language-preferences/label",
  ADD_EDIT_PAYMENT: "settings/payment-gateway",
  TWO_WAY_AUTHENTICATION: "settings/general/change-2fa-status",
  GET_TWO_WAY_AUTHENTICATION: "settings/general/get-2fa",
  //role
  GET_ALL_PERMISSSION: "role/get-all-permission",
  ROLE: "role",
  CHANGE_ROLE: "/role/change-role",
  ROLE_LISTING: "role/listing",
  USER_LIST: "role/user-list",

  //emailTemplates
  LISTING: "email-template/listing",
  STATUS_CHANGE: "email-template/change-status",
  EMAIL_TEMPLATES: "email-template",

  //blog
  BLOG_CATEGORY_LISTING: "blog-categories/listing",
  BLOG_CATEGORY: "blog-categories",
  BLOG_CATEGORY_LIST: "blog-categories/dropdown",
  BLOG_LIST: "blog/listing",
  BLOG: "blog",
  BLOG_LIST_DOWNLOAD: "blog/download",
  BLOG_PUBLISH: "blog/publish",
  BLOG_CATEGORY_DOWNLOAD: "blog-categories/download",

  //faq
  FAQ_CATEGORY_LISTING: "faq-categories/listing",
  FAQ_CATEGORY: "faq-categories",
  FAQ_CATEGORY_LIST: "faq-categories/dropdown",
  FAQ_LISTING: "faq/listing",
  FAQ: "faq",

  //users
  USER_LISTING: "admin/user/list",
  USER_DETAILS: "admin/user/details",
  DELETE_USER: "admin/user/delete",
  UPDATE_USER_STATUS: "admin/user/updateStatus",
  CHANGE_USER_STATUS: "admin/user/changeStatus",
  USER_DETAILS_DOWNLOAD: "admin/user/download",
  WORKER_BENEFITS_LIST: "/worker/benefit-list",
  ADMIN_WORKER_BENEFITS_LIST: "/worker/get-benefit-list-for-worker-add",
  WORKER_VISE_BENEFITS_LIST: "/worker/worker-benefits",

  //admin
  LISTING_ADMIN_MANAGEMENT: "admin-management",
  ADMIN_MANAGEMENT: "admin-management",
  ADMIN_USERS_DOWNLOAD: "admin-management/download",

  //Static page management
  STATIC_PAGE_MANAGEMENT_LISTING: "static-page/listing",
  STATIC_PAGE_MANAGEMENT: "static-page",
  STATIC_PAGE_MANAGEMENT_DOWNLOAD: "staticPage/download",

  //Commom Filter API
  SAVE_FILTER: "common/filter",
  SAVE_COLUMN: "common/column",

  //Support
  SUPPORT: "support",
  SUPPORT_REPLY: "support/reply",

  //category ==> super Levels
  ADD_SUPER_LEVELS: "/super-level",
  SUPER_LEVELS_LIST: "/super-level/listing",
  CHNAGE_SUPER_LEVELS: "/super-level",
  DELETE_SUPER_LEVELS: "/super-level",
  EDIT_SUPER_LEVELS: "/super-level",
  GET_SUPER_LEVELS_POINTS: "/super-level/get-latest-super-level",

  //category ==> LEVELS
  ADD_LEVELS: "/level",
  LEVELS_LIST: "/level/listing",
  CHNAGE_LEVELS: "/level",
  DELETE_LEVELS: "/level",
  EDIT_LEVELS: "/level",
  GET_LAVELS_POINTS: "/level/get-latest-level",

  //category ==> ACTION
  ADD_ACTIONS: "/action-point",
  ACTIONS_LIST: "/action-point/listing",
  CHNAGE_ACTIONS: "/action-point",
  DELETE_ACTIONS: "/action-point",
  EDIT_ACTIONS: "/action-point",
  ACTION_POINTS_DROPDOWN: "/default-action-points/dropdown/",
  CLUB_ADMIN_ACTION_LISTING: "club/action-point/listing",

  //manage club points
  ADD_CLUB_POINTS: "club/action-point",
  EDIT_CLUB_POINTS: "club/action-point/",

  //category ==> benefit
  ADD_BENEFIT: "/benefit",
  BENEFIT_LIST: "/benefit/listing",
  CHNAGE_BENEFIT: "/benefit",
  DELETE_BENEFIT: "/benefit",
  EDIT_BENEFIT: "/benefit",
  UPLOAD_BENEFIT_FILE: "/benefit/image-file-upload",
  CLUB_ADMIN_BENEFITS_LIST: "/club/benefit/listing",
  CLUB_ADMINS_BENEFITS: "/club/benefit",
  CLUB_ADMIN_UPLOAD_BENEFIT_FILE: "/club/benefit/image-file-upload",

  BRANDS_ADMIN_BENEFITS_LIST: "/brand/benefit/listing",
  BRANDS_ADMINS_BENEFITS: "/brand/benefit",
  BRANDS_ADMIN_UPLOAD_BENEFIT_FILE: "/brand/benefit/image-file-upload",
  WORKER_CHANGE_BENEFITS: "/benefit/change-sharable-status",

  //category ==> atmos
  ADD_ATMOSPHARE: "/atmosphere-range",
  ATMOSPHARE_LIST: "/atmosphere-range/listing",
  CHNAGE_ATMOSPHARE: "/atmosphere-range",
  DELETE_ATMOSPHARE: "/atmosphere-range",
  EDIT_ATMOSPHARE: "/atmosphere-range",
  UPLOAD_ATMOSPHARE_FILE: "/atmosphere-range/image-file-upload",
  GET_LATEST_ATMOSPHARE: "/atmosphere-range/get-latest-atmosphere",

  //category ==> atmos
  ADD_QUE_TYPE: "/que-type",
  QUE_TYPE_LIST: "/que-type/listing",
  CHNAGE_QUE_TYPE: "/que-type",
  DELETE_QUE_TYPE: "/que-type",
  EDIT_QUE_TYPE: "/que-type",
  UPLOAD_QUE_TYPE_FILE: "/que-type/image-file-upload",

  // clubs
  ADMIN_REGISTRATION: "/admin/",
  CLUB_LISTING: "/club/listing",
  CLUB_ADMIN_LISTING: "/club/admin/club-listing",
  ADD_CLUBS: "/club",
  UPLOAD_CLUBS_FILE: "/club/image-file-upload",
  UPLOAD_CLUBS_FILE_MINI: "/club/image-file-upload-mini",
  DELETE_CLUB: "/club",
  UPDATE_CLUB_STATUS: "/club/updateStatus",
  CHANGE_CLUB_STATUS: "/club",
  CLUB_DETAILS_DOWNLOAD: "/club/download",
  CLUB_ADMINS_LIST: "/admin/club-admin-listing",
  EDIT_CLUB_PROFILE: "/club",
  CLUB_DETAILS: "/club/details",
  //club posts list
  CLUB_POST_LIST: "/post/listing",
  UPLOAD_CLUBS_POST_FILE: "/post/image-file-upload",
  EDIT_CLUB_POST: "/post",
  ADD_CLUB_POST: "/post",
  DELETE_CLUB_POST: "/post",
  DELETE_CLUB_CO_OWNER: "/club-co-owner",

  //club weeks
  ADD_CLUBS_WEEK: "/club-weekly-schedule",
  CLUB_WEEK_LISTING: "/club-weekly-schedule/listing",
  EDIT_CLUBS_WEEK: "/club-weekly-schedule",
  EDIT_MULTI_CLUBS_WEEK: "/club-weekly-schedule-multi",
  GET_THE_BEST_DAYS: "/club/mark-the-best",
  GET_THE_BEST_DAYS_DATA: "/club/get-the-best-days",

  //club benefits
  CLUB_BENEFITS_FILE_UPLOAD: "/club-benefit-mapping/image-file-upload",
  ADD_CLUB_BENEFITS: "/club-benefit-mapping",
  GET_WEEK_BENEFITES_LISTING:
    "/club-benefit-mapping/club-profile-page-benefit-listing",
  ADD_CLUB_BENEFITS_DATA: "club-benefit-mapping/save",
  CLUB_BENEFITS_ACTION_POINTS:
    "/club-benefit-mapping/club-profile-page-action-points-listing",
  CLUB_BENEFIT_LISTING_EDIT:
    "/club-benefit-mapping/active-benefits-action-points-listing",
  CLUB_LEVEL_BENEFIT_LIST: "/club-benefit-mapping/active-benefits-listing",
  CLUB_MARK_BEST: "/club/mark-the-best",
  ADD_CLUB_FALSE_VOY: "/false-voy",
  EDIT_CLUB_FALSE_VOY: "/false-voy",
  CLUB_USERS_STATES: "/club/user-stats/dashboard",
  CLUB_TOP_USERS: "/club/user-stats/top-users",
  CLUB_LEVEL_WISE_USERS: "/club/user-stats/level-wise-users",
  CLUB_NAME_DROPDOWN: "/club/dropdown",
  CLUB_ADMIN_CLUBS_LIST: "/club/club-admin-club-dropdown",
  ADD_UPDATE_CLUB_FALSE_VOY: "/false-voy/add-update",
  ADD_NEW_CLUB_CO_OWNER_EMAIL: "/club-co-owner/add-new-club-co-owner",
  GET_NEW_CLUB_CO_OWNER_EMAIL: "/club-co-owner/get-club-co-owner-email",

  //Brand
  BRAND_NAME_DROPDOWN: "/brand/dropdown",
  ADD_BRANDS: "/brand",
  BRANDS_LIST: "/brand/list",
  UPLOAD_BRAND_IMAGES: "/brand/image-file-upload",
  CHANGE_BRAND: "/brand",
  DELETE_BRAND: "/brand",
  EDIT_BRAND: "/brand",
  BRAND_PROFILE_DETAILS: "/brand/details",
  DOWNLOAD_BRAND: "/admin/brand/download",
  BRAND_SURVEY_LIST: "/brand/surveys/list",
  ADD_BRAND_SURVEY: "/brand/surveys/add",
  EDIT_BRAND_SURVEY: "/brand/surveys/edit",
  DELETE_BRAND_SURVEY: "/brand/surveys/delete",
  GET_BRAND_SURVEY_DETAILS: "/brand/surveys",
  MARK_VERY_BEST: "/brand/mark-the-best",
  BRAND_ADMINS_LIST: "/admin/brand-admin-listing",
  BRAND_ACTION_POINTS_LISTING:
    "/brand-benefit-mapping/brand-profile-page-action-points-listing/",
  SAVE_BRAND_BENEFITS: "/brand-benefit-mapping/save",
  FILE_UPLOAD_BRAND_BENEFITS: "/brand-benefit-mapping/image-file-upload",
  BRAND_BENEFITS_MAPPING: "/brand-benefit-mapping",
  BRAND_BENEFITS_LISTING:
    "/brand-benefit-mapping/brand-profile-page-benefit-listing/",
  BRAND_SAVED_BENEFITS_LIST: "/brand-benefit-mapping/active-benefits-listing/",
  BRAND_INCREASE_TAG_COUNT: "/brand/increaseTagCount",
  BRAND_USERS_STATES: "/brand/user-stats/dashboard",
  BRAND_TOP_USERS: "/brand/user-stats/top-users",
  BRAND_LEVEL_WISE_USERS: "/brand/user-stats/level-wise-users",
  BRAND_DECREASE_TAG_COUNT: "/brand/decreaseTagCount",
  CLUB_LINK_LIST: "/brand-club-mapping",
  DELETE_CLUB_LINK_LIST: "/brand-club-mapping",
  ADD_NEW_BRAND_CO_OWNER_EMAIL: "/brand-co-owner/add-new-brand-co-owner",
  GET_NEW_BRAND_CO_OWNER_EMAIL: "/brand-co-owner/get-brand-co-owner-email",
  DELETE_BRAND_CO_OWNER: "/brand-co-owner",

  //manage promotion
  ADD_PROMOTION: "/promotion/create",
  EDIT_PROMOTION: "/promotion",
  PROMOTION_LIST: "/promotion/list",
  PROMOTION_DEATILS: "/promotion/detail/",
  DELETE_PROMOTION: "/promotion/delete/",
  GET_BENEFITS_LISTING: "/promotion/benefit/list",

  // dashboard
  SUPER_ADMIN_DASHBOARD: "admin/dashboard",
  CLUB_ADMIN_DASHBOARD: "club/admin/dashboard",
  BRAND_ADMIN_DASHBOARD: "brand/admin/dashboard",

  // worker
  WORKER_LIST: "/worker/listing",
  ADD_WORKER: "/worker/create-multiple-worker",
  EDIT_WORKER: "/worker/update-worker-details/",
  GET_EDIT_WORKER_DETAILS: "/worker/worker-details",
  DELETE_WORKER: "/worker/delete-assignment",
  CHANGE_WORKER_STATUS: "/worker/update-assignment-status",
  WORKER_ASSIGN: "/worker/assign-as-worker",
  WORKER_DETAILS_DOWNLOAD: "/worker/download",
  GET_USER_FAVOURAITE_CLUB: "/admin/user/details/get-favourite-clubs/",
  GET_USER_MOST_VOY_CLUB: "/admin/user/details/get-most-voy-clubs/",
  GET_USERS_TOP_LEVEL_CLUB: "/admin/user/details/get-clubs-level-list/",
  GET_USERS_BENEFITS_REDEEMED:
    "/admin/user/details/get-most-benefit-redeemed-clubs/",

  // statistics

  WORKER_STATISTICS_LIST: "/statistics/worker-statistics",
  WORKER_REAL_VOY_LIST: "/statistics/real-voy-breakdown",
  WORKER_REAL_BENEFITS_LIST: "/statistics/benefit-breakdown",
  WORKER_STATISTICS_DETAILS_DOWNLOAD: "/statistics/download-worker-statistics",
  WORKER_STATISTICS_REPORT_LIST: "/statistics/reports/list",
  API_STASTISCS_REPORT_LIST: "/statistics/report",
  WORKER_STATISTICS_REPORT_DOWNLOADS: "/mark-as-downloaded",

  //super admin reports
  SUPER_ADMIN_USER_REPORT_LIST: "/superAdmin/reports/user",
  DOWNLOAD_SUPER_ADMIN_USER_REPORT: "/admin/reports/user/download",

  SUPER_ADMIN_CLUB_REPORT_LIST: "/superAdmin/reports/club",
  DOWNLOAD_SUPER_ADMIN_CLUB_REPORT: "/admin/reports/club/download",

  SUPER_ADMIN_BRAND_REPORT_LIST: "/superAdmin/reports/brand",
  DOWNLOAD_SUPER_ADMIN_BRAND_REPORT: "/admin/reports/brand/download",

  ADMIN_MONITORING_REPORT_LIST: "/superAdmin/reports/monitors",
  DOWNLOAD_ADMIN_MONITORING_REPORT: "/admin/reports/monitor/download",

  CLUB_ADMIN_USER_REPORT_LIST: "/clubAdmin/reports/user",
  DOWNLOAD_CLUB_ADMIN_USER_REPORT: "/clubAdmin/reports/user/download",

  BRAND_ADMIN_USER_REPORT_LIST: "/brandAdmin/reports/user",
  DOWNLOAD_BRAND_ADMIN_USER_REPORT: "/brandAdmin/reports/user/download",

  GENDER_LIST: "/gender-mix/listing",
  GENDER_FILE_UPLOAD: "/gender-mix/image-file-upload",
  EDIT_GENDER: "/gender-mix",

  //admin wise club & brand list
  BRANDADMIN_BRAND_NAME_LIST: "/brand/admin/brand-list",
  CLUBADMIN_CLUB_NAME_LIST: "/club/admin/club-list",

  //brand promotion
  BRAND_ADMIN_PROMOTION_LIST: "/brand/admin/promotion-list",
  CLUB_ADMIN_PROMOTION_LIST: "/club/admin/promotion-list",

  //brand subscriber
  BRAND_SUBSCRIBER_LIST: "/brand/subscriber/list",
  BRAND_SUBSCRIBER_LIST_DOWNLOAD: "/brand/subscriber/list",

  //fourvenues
  FOURVENUES_ORG_LIST: "/fourvenues/org-list",
};
